export type StatusType = 'active' | 'inactive' | 'offline'

export interface StatusMetadata {
  type: StatusType
  label: string
  color: string
  timeAgo: string
}

const ACTIVE_THRESHOLD_MS = 5 * 60 * 1000       // 5 minutes
const INACTIVE_THRESHOLD_MS = 15 * 60 * 1000     // 15 minutes

const STATUS_COLORS: Record<StatusType, string> = {
  active: '#93E6B8',
  inactive: '#FEEE95',
  offline: '#EAECF0',
}

function formatTimeAgo(elapsedMs: number): string {
  const seconds = elapsedMs / 1000
  const minutes = seconds / 60
  const hours = minutes / 60

  if (seconds < 50) return 'less than a minute ago'
  if (seconds < 90) return '1 minute ago'
  if (minutes < 100) return `${Math.round(minutes)} minutes ago`
  if (hours < 36) return '1 day ago'
  return `${Math.round(hours / 24)} days ago`
}

export function getStatusMetadata(lastOnline: Date | string | null | undefined): StatusMetadata {
  if (!lastOnline) {
    return {
      type: 'offline',
      label: 'Offline',
      color: STATUS_COLORS.offline,
      timeAgo: 'Never',
    }
  }

  const lastOnlineDate = typeof lastOnline === 'string' ? new Date(lastOnline) : lastOnline
  const elapsed = Date.now() - lastOnlineDate.getTime()

  if (elapsed < ACTIVE_THRESHOLD_MS) {
    return {
      type: 'active',
      label: 'Active',
      color: STATUS_COLORS.active,
      timeAgo: formatTimeAgo(elapsed),
    }
  }

  if (elapsed < INACTIVE_THRESHOLD_MS) {
    return {
      type: 'inactive',
      label: 'Inactive',
      color: STATUS_COLORS.inactive,
      timeAgo: formatTimeAgo(elapsed),
    }
  }

  return {
    type: 'offline',
    label: 'Offline',
    color: STATUS_COLORS.offline,
    timeAgo: formatTimeAgo(elapsed),
  }
}
